import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {ValidationRules, ValidationController} from 'aurelia-validation';
import {BeverageTypeValueConverter} from 'util/beverage-type-value-converter';
import {Brod2ProductCategoryValueConverter} from 'util/brod2-product-category-value-converter';
import {Brod2BeerCalorieTypeValueConverter} from 'util/brod2-beer-calorie-type-value-converter';
import {Brod2SodaTasteValueConverter} from 'util/brod2-soda-taste-value-converter';
import numeral from "numeral";
import {FeatureCustomizationProvider} from "../util/feature-customization-provider";

@inject(Backend, Router, ValidationController, FeatureCustomizationProvider)
export class ProductCreateScreen {
    backend;
    router;
    validationRules;

    // For dropdowns
    beverageTypes;
    brod2ProductCategories;
    brod2BeerCalorieTypes;
    brod2SodaTastes;

    // To be posted
    product = {};

    saveError;
    router;
    featureCustomizationProvider;

    constructor(backendFacade, router, validationController, featureCustomizationProvider) {
        this.backend = backendFacade;
        this.router = router;
        this.validationController = validationController;
        this.featureCustomizationProvider = featureCustomizationProvider;
    }

    activate() {
        return this.refresh();
    }

    bind() {
        ValidationRules
          .ensure('name')
              .displayName('Navn')
              .required()
          .ensure('abv')
              .displayName('ABV')
              .required()
              .then()
              .satisfies(value => numeral.validate(value, 'en'))
              .withMessage('ABV må være et tall')
          .on(this.product);
    }

    refresh() {
        return Promise.all([
            this.backend.BeverageTypesForDropdownQueryHandler_handle()
              .then(result => this.beverageTypes = result.beverageTypes),
            this.backend.DropdownItemQueryHandler_handle('ProductCategory')
                .then(result => {
                  this.productCategories = result.items;
                  this.productCategories.unshift({id: null, name: 'Ingen'});
                }),
            this.backend.DropdownItemQueryHandler_handle('Brod2ProductCategory')
                .then(result => {
                  this.brod2ProductCategories = result.items;
                  this.brod2ProductCategories.unshift({id: null, name: ''});
                }),
            this.backend.DropdownItemQueryHandler_handle('Brod2BeerCalorieType')
                .then(result => {
                  this.brod2BeerCalorieTypes = result.items;
                  this.brod2BeerCalorieTypes.unshift({id: null, name: ''});
                }),
            this.backend.DropdownItemQueryHandler_handle('Brod2SodaTaste')
                .then(result => {
                  this.brod2SodaTastes = result.items;
                  this.brod2SodaTastes.unshift({id: null, name: ''});
                })
          ])
          .catch(error => this.queryError = "Error: " + error.toString())
    }

    createSubmit() {
        this.validationController.validate()
            .then(result => {
                if (!result.valid) {
                    return;
                }
                this.saveInProgress = true;
                this.backend.ProductCrud_create(this.product)
                    .then(() => this.router.navigateToRoute('product-index'))
                    .catch(error => this.saveError = error)
                    .then(() => this.saveInProgress = false)
                ;
            });
    }

    translateBeverageType(value) {
        return BeverageTypeValueConverter.toView(value);
    }

    translateBrod2ProductCategory(value) {
        return Brod2ProductCategoryValueConverter.toView(value);
    }

    translateBrod2BeerCalorieType(value) {
        return Brod2BeerCalorieTypeValueConverter.toView(value);
    }

    translateBrod2SodaTaste(value) {
        return Brod2SodaTasteValueConverter.toView(value);
    }

    dismissSaveError() {
        this.saveError = null;
    }
}
